import { AnimatePresence, motion } from "motion/react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { useEffect, useState, type FC, type PropsWithChildren } from "react";
import Modal from "../../components/general/Modal";
import ModalOverlay from "../../components/general/Modal/components/ModalOverlay/ModalOverlay";
import ModalPortal from "../../components/general/ModalPortal";

export type ProductPageModalProps = PropsWithChildren<{
	open: boolean;
	heading?: string;
	description?: string;
	onClose?: () => void;
}>;

const ProductPageModal: FC<ProductPageModalProps> = ({
	open,
	children,
	heading,
	description,
	onClose,
}) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(open);

	const closeModal = () => {
		if (onClose) onClose();
		setIsOpen(false);
	};

	useEffect(() => {
		setIsOpen(open);
	}, [open]);

	return (
		<ModalPortal show={!!isOpen}>
			<AnimatePresence>
				<ModalOverlay />
				<motion.div
					key="ProductPageModal"
					initial={{ x: "100%" }}
					animate={{ x: 0 }}
					exit={{ x: "100%" }}
					transition={{
						type: "spring",
						bounce: 0,
						duration: 0.4,
					}}
					style={{
						position: "fixed",
						top: 0,
						right: 0,
						zIndex: 101,
					}}
				>
					<Modal
						closeButtonLabel={t("Close")}
						overlayOnClick={closeModal}
						buttonOnClick={closeModal}
						heading={heading}
						description={description}
					>
						{children}
					</Modal>
				</motion.div>
			</AnimatePresence>
		</ModalPortal>
	);
};

export default ProductPageModal;
